import { GetMarketValueResponse } from '~/networking/api/trading/responses/market/GetMarketValueResponse';
import { type MakeMangedRequestOptions } from '~/networking/client';
import { httpRequest } from '~/networking/utils/httpRequest';

export const getMarketValue =
    ({ getHeaders, getRequestUrl }: MakeMangedRequestOptions) =>
    async (productIds: number | number[]) => {
        const slist = productIds.toString();
        if (!slist) {
            return { data: null };
        }
        const headers = getHeaders(true);
        const getMarketValueEndpoint = getRequestUrl(`/v1/markets/product?productIDs=${productIds.toString()}`);
        return httpRequest.get<GetMarketValueResponse>(getMarketValueEndpoint, { headers });
    };
